import _ from 'lodash'

const CATEGORY_COUNT = 4

export default (costs) => {
  const sorted = _.sortBy(costs, 'value')
  const top = _.takeRight(sorted, CATEGORY_COUNT)
  const bottom = _.dropRight(sorted, CATEGORY_COUNT)
  const combined = {
    label: 'Other',
    value: _.sumBy(bottom, 'value'),
  }

  return _.concat(top, [combined])
}
